<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col class="mt-sm-20">
          <v-col md="6" lg="6" sm="12" align-self="center" class="mx-auto">
            <v-img :src="require('@/assets/Vessel.jpg')" class="mt-sm-20" />
          </v-col>
          <v-col>
            <div class="rowq">
              <p>
                A ship tracking software system that offers dependable and
                prompt situational awareness to enhance decision-making.
                <br /><br />
                Vessel tracking delivers a nearly real-time snapshot of your
                fleet, encompassing security concerns, potential risks, and
                regulatory areas. We provide comprehensive situational
                awareness, offering worldwide visibility and practical insights
                to boost operational efficiency and ensure compliance.
                <br /><br />
                Our cutting-edge, integrated tracking technology and interactive
                maps provide flexibility and ease of use for fleet owners,
                managers, and charterers seeking comprehensive fleet-wide vessel
                monitoring.
              </p>
            </div>
          </v-col>
          <br />

          <v-row class="pt-5">
            <v-col cols="12" md="6" lg="4" sm="12">
              <h3>Features</h3>
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-format-list-checks
              </v-icon>
              <br />
              Tracking technology
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <h3>Interactive Maps</h3>
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-map-marker
              </v-icon>
              <br />
              Utilize functions such as zooming, panning, accessing weather
              layers, defining precise areas, and employing a distance
              measurement tool.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <h3>Event Notifications</h3>
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-bell-ring
              </v-icon>
              <br />
              Establish automatic alerts for ships entering or exiting crucial
              zones, such as Exclusive Economic Zones (EEZs) and high-risk
              piracy areas, and receive notifications through email and SMS.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <h3>Historical Tracking</h3>
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-clock
              </v-icon>
              <br />
              Examine a ship's navigational data with just a single click to
              enable in-depth analysis.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <h3>Report Engine</h3>
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-file-chart
              </v-icon>
              <br />
              Generate ship movement reports that are immune to tampering,
              suitable for analytical purposes, arbitration support, or as
              evidence of adherence to insurance requirements, sanctions
              regulations, environmental commitments, and conservation measures.
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col sm="12" md="5" lg="5">
              <div>
                <base-request />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading =
      "Maritech Vessel Tracking Solution";
  }
};
</script>
<style scoped>
@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
